import Breadcrumb from 'components/Layout/ApplicationLayout/Breadcrumb';
import LayoutDefault from 'components/Layout/LayoutDefault';
import FormTrackingCode from 'page/Application/ManageTrackingCode/component/FormTrackingCode';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import { useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { MANAGE_TRACKING_CODE_PATH } from 'constant/appPath';
import {
  deleteTrackingCode,
  editTrackingCode,
  getDetailTrackingCode,
} from 'api/trackingCode/trackingCode.api';
import useErrorCodeTrackingCode from 'page/Application/ManageTrackingCode/hook/useErrorCodeTrackingCode';
import useCustomMutateRenderMessage from 'hook/useQuery/useCustomMutateRenderMessage';
import useCustomQuery from 'hook/useQuery/useCustomQuery';
import useSetTitlePage from 'hook/useSetTitlePage';
import useCustomMutate from 'hook/useQuery/useCustomMutate';

const EditTrackingCode = () => {
  const { useQueryAPI } = useCustomQuery();
  const { codeId } = useParams();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();
  const { ERROR_CODE_TRACKING_CODE } = useErrorCodeTrackingCode();
  const { useMutationAPIHandleErrorCode, errorMessage } =
    useCustomMutateRenderMessage({ errorCode: ERROR_CODE_TRACKING_CODE });
  const [isDisable, setIsDisable] = useState(false);
  const [isDisableDelete, setIsDisableDelete] = useState(false);
  const { useMutationAPI } = useCustomMutate();

  const listItem = useMemo(() => {
    return [
      {
        title: <Link to={'/'}>企業管理</Link>,
      },
      {
        title: (
          <Link to={`/${MANAGE_TRACKING_CODE_PATH}`}>トラッキングコード</Link>
        ),
      },
      {
        title: 'トラッキングコード編集',
      },
    ];
  }, []);

  const { data: trackingCodeDetail, isLoading } = useQueryAPI({
    api: getDetailTrackingCode,
    key: 'trackingCodeDetail',
    params: {
      trackingCodeId: codeId,
    },
  });

  const {
    mutate: editTrackingCodeMutate,
    isError,
    isLoading: isLoadingSubmit,
  } = useMutationAPIHandleErrorCode({
    refetchKey: 'editTrackingCode',
    api: editTrackingCode,
    messageSuccess: 'トラッキングコード情報を変更しました。',
    path: `/${MANAGE_TRACKING_CODE_PATH}`,
  });

  const { mutate: deleteTrackingCodeMutate } = useMutationAPI({
    api: deleteTrackingCode,
    refetchKey: 'trackingCodeDelete',
    messageSuccess: 'トラッキングコード1件を削除しました。',
    path: `/${MANAGE_TRACKING_CODE_PATH}`,
  });

  const onFinish = (values) => {
    const payload = {
      title: values?.title,
      header: values?.header,
      body: values?.body,
    };
    if (isOnline) {
      editTrackingCodeMutate({ trackingCodeId: codeId, payload: payload });
    } else {
      errorNetWork();
    }
  };

  const handleDeleteTrackingCode = () => {
    if (isOnline) {
      const payload = {
        listTrackingCodeId: [codeId],
        isAll: false,
      };
      deleteTrackingCodeMutate(payload);
    } else {
      errorNetWork();
    }
  };

  useSetTitlePage(`トラッキングコード編集 | Soliton パートナーサイト`, true);

  return (
    <>
      {contextErrorNetWork}
      <Breadcrumb listItem={listItem} titlePage="トラッキングコード編集" />
      <LayoutDefault>
        <FormTrackingCode
          titleForm={
            '変更した内容は画面の下部に「保存」ボタンを押下した場合のみに、保存される。'
          }
          onFinish={onFinish}
          isEdit={true}
          isDisable={isDisable}
          setIsDisable={setIsDisable}
          isOnline={isOnline}
          isLoading={isLoading}
          errorNetWork={errorNetWork}
          errorMessage={errorMessage}
          isError={isError}
          isLoadingSubmit={isLoadingSubmit}
          formDetailData={trackingCodeDetail}
          handleDeleteTrackingCode={handleDeleteTrackingCode}
          isDisableDelete={isDisableDelete}
          setIsDisableDelete={setIsDisableDelete}
        />
      </LayoutDefault>
    </>
  );
};

export default EditTrackingCode;
